import _ from "lodash-es";

const ChartsBudgetsDataCompute = (props, edges) => {
  // console.log("===> Compute", props);
  const { intl } = props;

  if (edges) {
    let mapPeriode = new Map();
    let mapPeriodeNegative = new Map();

    var typePeriode = props.currentPeriod;
    var currentYear = props.currentYear;

    let previousYearStr = (props.currentYear - 1).toString();
    let currentYearStr = props.currentYear.toString();

    // filter
    let filterPeriod = props.selectedPeriod + 1;
    //console.log(">>>", filterPeriod);

    filterPeriod = ("0" + filterPeriod).slice(-2);
    //console.log(">>>", filterPeriod);

    if (props.currentPeriod === "Q")
      filterPeriod = "Q" + (props.selectedPeriod + 1);
    // filter
    if (props.currentPeriod === "S")
      filterPeriod = "S" + (props.selectedPeriod + 1);

    if (props.currentPeriod === "N")
      filterPeriod = "N" + (props.selectedPeriod + 1);

    let data = [];

    for (let j = 0, lenj = edges.length; j < lenj; j++) {
      // console.log("#" + j + " -", edges[j].node);

      const strDate = "" + edges[j].node.year + "-" + ("0" + edges[j].node.month).slice(-2) + "-10T00:00:00.000Z";
      let tmpDate = new Date(strDate);

      let key = "";
      let keyPreviousYear = "";
      // let keyYear = tmpDate.getFullYear().toString();
      let key2 = "";

      switch (typePeriode) {
        case "Q":
          key = tmpDate.getFullYear().toString() + "-";
          keyPreviousYear = (tmpDate.getFullYear() - 1).toString() + "-";
          switch (tmpDate.getMonth() + 1) {
            case 1:
            case 2:
            case 3:
              key = key + "Q1";
              keyPreviousYear = keyPreviousYear + "Q1";
              key2 = "Q1";
              break;

            case 4:
            case 5:
            case 6:
              key = key + "Q2";
              keyPreviousYear = keyPreviousYear + "Q2";
              key2 = "Q2";
              break;

            case 7:
            case 8:
            case 9:
              key = key + "Q3";
              keyPreviousYear = keyPreviousYear + "Q3";
              key2 = "Q3";
              break;

            case 10:
            case 11:
            case 12:
              key = key + "Q4";
              keyPreviousYear = keyPreviousYear + "Q4";
              key2 = "Q4";
              break;

            default:
              break;
          }
          break;

        case "S":
          key = tmpDate.getFullYear().toString() + "-";
          keyPreviousYear = (tmpDate.getFullYear() - 1).toString() + "-";
          switch (tmpDate.getMonth() + 1) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              key = key + "S1";
              keyPreviousYear = keyPreviousYear + "S1";
              key2 = "S1";
              break;

            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
              key = key + "S2";
              keyPreviousYear = keyPreviousYear + "S2";
              key2 = "S2";
              break;

            default:
              break;
          }
          break;

        case "N":
          key = tmpDate.getFullYear().toString() + "-";
          keyPreviousYear = (tmpDate.getFullYear() - 1).toString() + "-";
          switch (tmpDate.getMonth() + 1) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
              key = key + "N1";
              keyPreviousYear = keyPreviousYear + "N1";
              key2 = "N1";
              break;

            case 10:
            case 11:
            case 12:
              key = key + "N2";
              keyPreviousYear = keyPreviousYear + "N2";
              key2 = "N2";
              break;

            default:
              break;
          }
          break;

        case "Y":
          key = tmpDate.getFullYear().toString();
          keyPreviousYear = (tmpDate.getFullYear() - 1).toString();
          key2 = "Y";
          break;

        case "M":
        default:
          key =
            tmpDate.getFullYear().toString() +
            "-" +
            ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);

          keyPreviousYear =
            (tmpDate.getFullYear() - 1).toString() +
            "-" +
            ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);

          key2 = ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);
          break;
      }

      // Periode
      let tmpValue = mapPeriode.get(key);
      if (tmpValue === undefined) tmpValue = 0.0;
      const amount = edges[j].node.realValue;
      tmpValue = _.round(tmpValue + amount, 2);
      mapPeriode.set(key, tmpValue);

      // // Periode2
      // let tmpValue2 = mapPeriodeNegative.get(keyPreviousYear);
      // if (tmpValue2 === undefined) tmpValue2 = 0.0;
      // const amount2 = edges[j].node.previousYearRealValue;
      // tmpValue2 = _.round(tmpValue2 + amount2, 2);      
      // mapPeriodeNegative.set(keyPreviousYear, tmpValue2);

      // Periode3
      let tmpValue3 = mapPeriode.get(keyPreviousYear);
      if (tmpValue3 === undefined) tmpValue3 = 0.0;
      const amount3 = edges[j].node.amount;
      tmpValue3 = _.round(tmpValue3 + amount3, 2);
      mapPeriode.set(keyPreviousYear, tmpValue3);

      // build table data item
      if (filterPeriod === key2 || typePeriode === "Y") {
        const amount = props.negateValues
          ? -edges[j].node.amount
          : edges[j].node.amount;

        let year = tmpDate.getFullYear().toString();
        const currentYearAmount = currentYearStr === year ? amount : 0;
        const previousYearAmount = previousYearStr === year ? amount : 0;
        const amountVariation = _.round(
          currentYearAmount - previousYearAmount,
          2
        );
        const amountVariationPourcent = _.round(
          ((currentYearAmount - previousYearAmount) / previousYearAmount) *
          100.0,
          2
        );

        const item = {
          ...edges[j].node,
          amount,
          currentYearAmount,
          previousYearAmount,
          amountVariation,
          amountVariationPourcent,
          period: key2
        };

        data.push(item);
      }
    }
    console.log("mapPeriode", mapPeriode);
    //console.log("mapPeriodeCategory", mapPeriodeCategory);

    let sourcePreviousYearData = {};
    let sourceCurrentYearData = {};

    let sourcePreviousYearDataNegative = {};
    let sourceCurrentYearDataNegative = {};
    let tmpCumul = 0.0;

    switch (typePeriode) {
      case "Q":
        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q3");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q4");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q3");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q4");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        //PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q3");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q4");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q3");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q4");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;

      case "S":
        tmpCumul = mapPeriode.get(currentYear - 1 + "-S1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-S2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-S1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-S2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        //PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-S1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-S2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-S1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-S2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;

      case "N":
        tmpCumul = mapPeriode.get(currentYear - 1 + "-N1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-N2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-N1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-N2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        //PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-N1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-N2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-N1");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })         
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-N2");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;

      case "Y":
        tmpCumul = mapPeriode.get((currentYear - 1).toString());
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear.toString());
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get((currentYear - 1).toString());
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear.toString());
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;
        break;

      case "M":
      default:
        tmpCumul = mapPeriode.get(currentYear - 1 + "-01");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-02");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-03");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-04");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-05");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_may" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-06");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-07");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-08");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-09");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-10");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-11");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-12");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-01");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-02");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-03");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-04");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-05");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[intl.formatMessage({ id: "ids_may" })] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-06");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-07");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-08");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-09");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-10");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-11");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-12");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        // PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-01");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-02");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-03");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-04");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-05");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_may" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-06");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-07");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-08");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-09");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-10");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-11");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-12");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-01");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-02");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-03");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-04");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-05");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_may" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-06");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-07");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-08");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-09");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-10");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-11");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-12");
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;
    }

    // console.log("Source current=", sourceCurrentYearData);
    // console.log("Negative current=", sourceCurrentYearDataNegative);

    // console.log("Source previous=", sourcePreviousYearData);
    // console.log("Negative previous=", sourcePreviousYearDataNegative);

    // console.log("tabData=", data);

    return {
      //periodCategory: mapPeriodeCategory,
      previousYearData: sourcePreviousYearData,
      currentYearData: sourceCurrentYearData,
      previousYearDataNegative: sourcePreviousYearDataNegative,
      currentYearDataNegative: sourceCurrentYearDataNegative,
      tabData: data
    };
  }
};

export default ChartsBudgetsDataCompute;
